import React from "react";
import { useNavigate } from "react-router-dom";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonDettaglioProdotto = () => {
  const navigate = useNavigate();

  return (
    <SkeletonTheme baseColor="#1A1F2B" highlightColor="#2A2F3A">
      <main className="min-h-safe-screen bg-[#0D111A] text-secondary pb-28 pt-[64px] relative">
        {/* Header */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-[#1A1F2B] px-4 py-3 border-b border-[#21242E] shadow-md">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate("/menu")}
              className="text-secondary p-2"
              aria-label="Torna al menu"
            >
              <Skeleton width={24} height={24} />
            </button>
            <div className="flex items-center gap-2 text-sm">
              <Skeleton circle width={20} height={20} />
              <Skeleton width={100} height={16} />
            </div>
            <div className="w-6" />
          </div>
        </header>

        {/* Immagine */}
        <div className="px-6 pt-6">
          <div className="relative mx-auto w-72 h-72 rounded-full overflow-hidden border-4 border-primary bg-[#181818] shadow-[0_0_60px_rgba(233,69,69,0.2)]">
            <Skeleton width={"100%"} height={"100%"} circle />
          </div>
        </div>

        {/* Titolo */}
        <div className="mt-5 text-center px-4">
          <Skeleton width={180} height={22} className="mx-auto" />
        </div>

        {/* Contenuto */}
        <section className="px-6 max-w-md mx-auto space-y-6 pt-6">
          {/* Info blocco */}
          <div className="flex justify-between items-start bg-[#1A1F2B] border border-[#21242E] rounded-xl p-4 shadow text-sm">
            <div className="flex-1 text-left space-y-2">
              <Skeleton width={60} height={16} />
              <Skeleton width={50} height={14} />
            </div>
            <div className="flex-1 text-center">
              <Skeleton width={80} height={30} />
            </div>
            <div className="flex-1 text-right space-y-2">
              <Skeleton width={60} height={16} />
              <Skeleton width={50} height={14} />
            </div>
          </div>

          {/* Descrizione */}
          <div>
            <Skeleton width={100} height={18} className="mb-2" />
            <Skeleton count={3} />
          </div>

          {/* Ingredienti */}
          <div>
            <Skeleton width={100} height={18} className="mb-2" />
            <Skeleton count={2} />
          </div>

          {/* Extra */}
          <div>
            <Skeleton width={100} height={18} className="mb-2" />
            <Skeleton count={1} />
          </div>

          {/* Allergeni */}
          <div>
            <Skeleton width={100} height={18} className="mb-2" />
            <Skeleton count={1} />
          </div>
        </section>

        {/* Navigazione Placeholder */}
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 w-[90%] bg-[#1A1F2B] border border-[#21242E] rounded-2xl px-6 py-3 flex justify-between items-center text-sm z-30 shadow-xl">
          <Skeleton width={80} height={16} />
          <Skeleton width={40} height={16} />
          <Skeleton width={80} height={16} />
        </div>
      </main>
    </SkeletonTheme>
  );
};

export default SkeletonDettaglioProdotto;